export default __webpack_public_path__ + "static/media/check.aa01c827.svg";